export default {"src":"/_next/static/image/public/images/social_insta_white.c14ca248222368ab218869b20b24f508.svg","height":16,"width":16};